/**
 * Created by stonewang on 2017/8/29.
 */
import {config, request,objectSerial} from 'Utils';


/*获取购销单位数据*/
export function getGouXiaoUnitList(param) {
    return request(`${config.server}/api/v1/dms/dmsPurchase/list`, {
        method: 'post',
        body: {...param}
    });
}

/*获取产品线数据*/
export function getProductLineList() {
    return request(`${config.server}/api/v1/dmsOrderManage/productLine`, {
        method: 'get'
    });
}



/*获取添加追溯订单列表数据*/
export function getAddOrderTraceBackList(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/addOrderTraceBack`, {
        method: 'post',
        body: param
    });
}

/*获取追溯订单物料列表数据*/
export function getOrderTraceBackItemList(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/orderTraceBackItemList`, {
        method: 'post',
        body: {...param}
    });
}

/*获取修改物料列表数据*/
export function getUpdateorderTraceBackItem(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/updateorderTraceBackItem`, {
        method: 'get',
        body: {...param}
    });
}

/*删除物料列表数据*/
export function getDelOrderTraceBackItem(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/delOrderTraceBackItem`, {
        method: 'post',
        body: param
    });
}






/*清除历史数据*/
export function clearOrderTraceBackItem() {
    return request(`${config.server}/api/v1/dms/tzOrderSync/clearOrderTraceBackItem`, {
        method: 'get'
    });
}
/*****以上改好*******/

/*删除*/
export function deleteList(param) {
    return request(`${config.server}/api/v1/dms/trans/order/deleteOrderProduct`, {
        method: 'post',
        body: param
    });
}

/*获取订单详情数据*/
export function detail(param) {
    return request(`${config.server}/api/v1/dms/trans/order/detail`, {
        method: 'post',
        body: {...param}
    });
}

/*点击搜索订单商品*/
export function getPro(param) {
    return request(`${config.server}/api/v1/dms/product/listPc`, {
        method: 'post',
        body: param
    });
}

/*点击保存提交按钮*/
export function create(param) {
    return request(`${config.server}/api/v1/dms/trans/order/createOrder`, {
        method: 'post',
        body: {...param}
    });
}


// 已有物料
export function getProTypes(param) {
    return request(`${config.server}/api/v1/dms/tgCustomOrder/selectProType`, {
        method: 'post',
        body: {...param}
    });
}


//----------------------------------zhangqingfu--------------------------
// 查询客户信息
export function getCustomer() {
    return request(`${config.server}/api/v1/dms/tzOrderTraceHeadBack/customer`, {
        method: 'get',

    });
}

// 查询客户信息  传入 channelCode
export function getPurchases(param) {
    return request(`${config.server}/api/v1/dms/tzOrderTraceHeadBack/purchase?${objectSerial(param)}`,{
        method: 'get',
    });
}

/*获取订单列表数据*/
export function getOrderTraceBackistList(param) {
    return request(`${config.server}/api/v1/dms/tzOrderTraceHeadBack/list`, {
        method: 'post',
        body: {...param}
    });
}
/*获取选择物料数据*/
export function getChooseOrderTraceBackList(param) {
    return request(`${config.server}/api/v1/dms/tzOrderTraceHeadBack/itemList`, {
        method: 'post',
        body: {...param}
    });
}
/*提交追溯订单数据*/
export function submitOrderTraceBack(param) {
    return request(`${config.server}/api/v1/dms/tzOrderTraceHeadBack/submitOrderTraceBack`, {
        method: 'post',
        body: {...param}
    });
}
/*获取详情*/
export function getOrderTraceBackHead(id) {
    return request(`${config.server}/api/v1/dms/tzOrderTraceHeadBack/detail?id=${id}`, {
        method: 'get',
    });
}
export function saveOrderTraceBack(param){
    return request(`${config.server}/api/v1/dms/tzOrderTraceHeadBack/save`, {
        method: 'post',
        body: {...param}
    });
}
export function  deleterRecord(param) {
    return request(`${config.server}/api/v1/dms/tzOrderTraceHeadBack/delete`, {
        method: 'get',
        body: {...param}
    });
}


// WEBPACK FOOTER //
// ./src/service/traceOrder/index.js